export const authorizationBaseUrl = process.env.VUE_APP_AUTHORIZATION_BASE_URL
export const projectBaseUrl = process.env.VUE_APP_PROJECT_BASE_URL
export const notificationBaseUrl = process.env.VUE_APP_NOTIFICATION_BASE_URL
export const companyBaseUrl = process.env.VUE_APP_COMPANY_BASE_URL
export const userBaseUrl = process.env.VUE_APP_USER_BASE_URL

export const headersmixins = {
    'Content-Type': 'application/vnd.api+json',
}

export function getURL({
    base,
    path,
    params,
}: {
    path: string
    base?: string
    params?: Record<string, any>
}) {
    let url = new URL(path, base)
    for (let key in params) {
        url.searchParams.append(key, encodeURIComponent(params[key]))
    }
    return decodeURIComponent(url.toString())
}

export function getRequestHeaders(
    httpMethod: 'GET' | 'POST' | 'PATCH' | 'DELETE' = 'GET',
    updatedAt?: string
) {
    return headersmixins
}
